
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ISocialThemeItem } from '../interfaces/social-theme-item';
import ImageRatioMolecule from '@/shared/components/molecules/ImageRatioMolecule.vue'

@Component({
    components: {
        ImageRatioMolecule
    }
})
export default class SocialThemeItemComponent extends Vue {
    @Prop() public item!: ISocialThemeItem;
}

